import { Button } from "antd";
import axios from '../../../context/axiosConfig'

const DownloadXML = ({ fileName }) => {
    const downloadXML = async () => {
        try {
            const response = await axios.post("/rezerwy/download/xml", {
                filename: fileName
            }, {
                responseType: 'blob' // Important to handle file as binary
            });

            // Create a Blob from the response
            const blob = new Blob([response.data], { type: 'application/xml' });
            const link = document.createElement('a');

            // Create a link to the file
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

        } catch (error) {
            console.error("Błąd pobierania pliku:", error);
        }
    };

    return <Button onClick={() => downloadXML()}>Pobierz XML</Button>;
};

export default DownloadXML;